import React from 'react';
import "./tab.scss";
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import RainIconBlue from '../../../images/wind-icons/Rain-Icon-Blue.svg';
import RainIcon from '../../../images/wind-icons/Rain-Icon-Grey.svg';

const images = require.context('../../../images/wind-icons/', true);
const weatherImages = require.context('../../../images/weather-icons/', true);


const Tab = (props) => {
  let windIcon =  images('./blank.svg');

  if (typeof(props.day.windDirection) != "undefined" && props.day.windDirection !== null)
    windIcon =  images('./'+props.day.windDirection+'.svg');

  let weatherIcon =  weatherImages('./blank.svg');
  if (typeof(props.day.dayIcon) !== "undefined" && props.day.dayIcon !== null)
    weatherIcon =  weatherImages('./'+props.day.dayIcon);
  
  var windSpeed = props.day.windSpeed;
  let maxTemp = props.day.maxTemp;
  let minTemp = props.day.minTemp;
    

  if (props.windMode === "Miles") {
    windSpeed = props.day.windSpeedMPH;
  }

  if (props.windMode === "Kilometres") {
    windSpeed = props.day.windSpeedKM;
  }

  if (props.windMode === "Knots") {
    windSpeed = props.day.windSpeedKnots;
  }

  if (props.tempMode !== "Celsius") {
    maxTemp = props.day.maxTempFahrenheit;
    minTemp = props.day.minTempFahrenheit;
  }

  //1280
  const MD = useMediaQuery('(max-width:1680px)');

  let rain = Math.max(props.day.rainProbMorning, props.day.rainProbAfternoon)
  if (props.Afternoon)
    rain = props.day.rainProbAfternoon
  if (props.Evening)
    rain = props.day.rainProbEvening

  if (props.day.windDirection === null) return null;
  return (
    <React.Fragment>
      <div className="weathergridsmall" style={{ marginRight: props.last ? "0": "25px"}} >

      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign: "left"}}>
        <div style={{display:"inline"}} className="boldWeatherTab">{props.day.dayName}</div>
        </Grid>
      </Grid>
      
    {MD ? <>
      <Grid container alignItems="center">
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <Tooltip title={props.day.dayToolTip} aria-label={props.day.dayToolTip}>
              <img className="weatherIconTab" src={weatherIcon.default} alt={props.day.dayToolTip + " " + props.day.dayIcon}/>
              </Tooltip>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <div className="boldWeatherSmall" style={{paddingRight:"10px"}}><span style={{fontWeight:"600"}}>{props.Evening ? minTemp : maxTemp}</span></div>
            </Grid>
          </Grid>

            <Grid container alignItems="center">
             <Grid item xs={6} sm={6} md={6} lg={6}>
              <div className="windTab">
                <img className="windIconTab" src={windIcon.default} alt="" />                
                  {props.windMode === "Miles" && 
                  <Tooltip title={props.day.windToolTipMPH} aria-label={props.day.windToolTipMPH}>
                    <div className="windSpeedTab">{windSpeed}</div>
                  </Tooltip>}
      
                  {props.windMode === "Kilometres" && 
                  <Tooltip title={props.day.windToolTipKM} aria-label={props.day.windToolTipKM}>
                    <div className="windSpeedTab">{windSpeed}</div>
                  </Tooltip>}
      
                  {props.windMode === "Knots" && 
                  <Tooltip title={props.day.windToolTipKnots} aria-label={props.day.windToolTipKnots}>
                    <div className="windSpeedTab">{windSpeed}</div>
                  </Tooltip>}
      
                  {props.windMode !== "Knots" && props.windMode !== "Kilometres" && props.windMode !== "Miles" &&
                  <Tooltip title={props.day.windToolTip} aria-label={props.day.windToolTip}>
                    <div className="windSpeedTab">{windSpeed}</div>
                  </Tooltip>}
              </div> 
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} style={{color:"#1d1d1b"}}>
              {rain}%<br />
              <Tooltip title="Rain" aria-label="Rain">
              { rain > 19 ? <img className="rainIcon" src={RainIconBlue} alt=""/> : <img className="rainIcon" src={RainIcon} alt=""/> }
              </Tooltip>             
            </Grid>
          </Grid>
    </> : <>
      <Grid container alignItems="center">
       
        <Grid item xs={4} sm={4} md={4} lg={4}>
        <Tooltip title={props.day.dayToolTip} aria-label={props.day.dayToolTip}>
          <img style={{paddingTop:"5px"}} className="weatherIconTab" src={weatherIcon.default} alt={props.day.dayToolTip + " " + props.day.dayIcon}/>
        </Tooltip>
        </Grid>

        <Grid item xs={4} sm={4} md={4} lg={4}>
        <div className="boldWeatherSmall"><span style={{fontWeight:"600"}}>{props.Evening ? minTemp : maxTemp}</span></div> 
        </Grid>

        <Grid item xs={4} sm={4} md={4} lg={4}>
        <div >
        <div className="windTab">
                <img className="windIconTab" src={windIcon.default} alt="" />
                
                  {props.windMode === "Miles" && 
                  <Tooltip title={props.day.windToolTipMPH} aria-label={props.day.windToolTipMPH}>
                  <div className="windSpeedTab">{windSpeed}</div>
                  </Tooltip>}
      
                  {props.windMode === "Kilometres" && 
                  <Tooltip title={props.day.windToolTipKM} aria-label={props.day.windToolTipKM}>
                  <div className="windSpeedTab">{windSpeed}</div>
                  </Tooltip>}
      
                  {props.windMode === "Knots" && 
                  <Tooltip title={props.day.windToolTipKnots} aria-label={props.day.windToolTipKnots}>
                  <div className="windSpeedTab">{windSpeed}</div>
                  </Tooltip>}
      
                  {props.windMode !== "Knots" && props.windMode !== "Kilometres" && props.windMode !== "Miles" &&
                  <Tooltip title={props.day.windToolTip} aria-label={props.day.windToolTip}>
                  <div className="windSpeedTab">{windSpeed}</div>
                  </Tooltip>}
              </div> 
        <div>
        {rain}%<br />
            <Tooltip title="Rain" aria-label="Rain">
            { rain > 19 ? <img className="rainIcon" src={RainIconBlue} alt=""/> : <img className="rainIcon" src={RainIcon} alt=""/> }
            </Tooltip>
        </div>
        </div> 
        
              
        </Grid>

        </Grid>
          </>
        }
      </div>    
    </React.Fragment>
  )
}

export default Tab
